import { Link } from 'react-router-dom';
import { Crown, Instagram, Mail, Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-maroon-900 text-white">
      {/* Pattern overlay */}
      <div className="relative">
        <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23d4af37'%3E%3Cpath d='M30 0l30 30-30 30L0 30z'/%3E%3C/g%3E%3C/svg%3E")`
        }} />
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 relative">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {/* Brand */}
            <div className="col-span-2 md:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-gold-400 to-gold-600 flex items-center justify-center">
                  <Crown className="w-5 h-5 text-maroon-900" />
                </div>
                <span className="text-xl font-heading font-bold text-white">
                  PlanMyShaadi
                </span>
              </Link>
              <p className="text-cream-200/70 mb-5 text-sm leading-relaxed">
                Canada's premier South Asian wedding planning platform. Creating unforgettable celebrations.
              </p>
              <div className="flex gap-3">
                <a href="https://instagram.com/planmyshaadi.ca" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-xl bg-white/10 border border-gold-500/30 flex items-center justify-center hover:bg-gold-500/20 hover:border-gold-400 transition-all">
                  <Instagram className="w-5 h-5 text-gold-400" />
                </a>
                <a href="mailto:admin@planmyshaadi.ca" className="w-10 h-10 rounded-xl bg-white/10 border border-gold-500/30 flex items-center justify-center hover:bg-gold-500/20 hover:border-gold-400 transition-all">
                  <Mail className="w-5 h-5 text-gold-400" />
                </a>
              </div>
            </div>

            {/* Vendors */}
            <div>
              <h4 className="font-heading font-semibold text-gold-400 mb-5 text-lg">Vendors</h4>
              <ul className="space-y-3">
                <li><Link to="/vendors?category=venues" className="text-cream-200/70 hover:text-gold-300 transition-colors text-sm">Venues</Link></li>
                <li><Link to="/vendors?category=photographers" className="text-cream-200/70 hover:text-gold-300 transition-colors text-sm">Photographers</Link></li>
                <li><Link to="/vendors?category=makeup" className="text-cream-200/70 hover:text-gold-300 transition-colors text-sm">Makeup Artists</Link></li>
                <li><Link to="/vendors?category=mehndi" className="text-cream-200/70 hover:text-gold-300 transition-colors text-sm">Mehndi Artists</Link></li>
                <li><Link to="/vendors?category=catering" className="text-cream-200/70 hover:text-gold-300 transition-colors text-sm">Caterers</Link></li>
              </ul>
            </div>

            {/* Planning */}
            <div>
              <h4 className="font-heading font-semibold text-gold-400 mb-5 text-lg">Planning</h4>
              <ul className="space-y-3">
                <li><Link to="/planning" className="text-cream-200/70 hover:text-gold-300 transition-colors text-sm">Checklist</Link></li>
                <li><Link to="/planning" className="text-cream-200/70 hover:text-gold-300 transition-colors text-sm">Budget Tracker</Link></li>
                <li><Link to="/invitations" className="text-cream-200/70 hover:text-gold-300 transition-colors text-sm">E-Invitations</Link></li>
                <li><Link to="/inspiration" className="text-cream-200/70 hover:text-gold-300 transition-colors text-sm">Inspiration</Link></li>
              </ul>
            </div>

            {/* Company */}
            <div>
              <h4 className="font-heading font-semibold text-gold-400 mb-5 text-lg">Company</h4>
              <ul className="space-y-3">
                <li><Link to="/blog" className="text-cream-200/70 hover:text-gold-300 transition-colors text-sm">Blog</Link></li>
                <li><Link to="/become-vendor" className="text-cream-200/70 hover:text-gold-300 transition-colors text-sm">For Vendors</Link></li>
                <li><Link to="/about" className="text-cream-200/70 hover:text-gold-300 transition-colors text-sm">About Us</Link></li>
                <li><Link to="/faq" className="text-cream-200/70 hover:text-gold-300 transition-colors text-sm">FAQs</Link></li>
                <li><a href="mailto:admin@planmyshaadi.ca" className="text-cream-200/70 hover:text-gold-300 transition-colors text-sm">Contact</a></li>
              </ul>
            </div>
          </div>

          {/* Bottom */}
          <div className="mt-12 pt-8 border-t border-gold-500/20 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-cream-200/60">
              © {currentYear} PlanMyShaadi.ca. Made with <Heart className="w-3.5 h-3.5 inline text-maroon-400 fill-maroon-400" /> in Toronto
            </p>
            <div className="flex gap-6">
              <Link to="/about" className="text-sm text-cream-200/60 hover:text-gold-300 transition-colors">About Us</Link>
              <Link to="/privacy" className="text-sm text-cream-200/60 hover:text-gold-300 transition-colors">Privacy</Link>
              <Link to="/terms" className="text-sm text-cream-200/60 hover:text-gold-300 transition-colors">Terms</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
